function togglePassword ( event ) {
    const ATTRIBUTE_INPUT_FLAG = "data-password-input";
    let $el = event.target.closest( "button.toggle-password" ),
        $commonParent, $passwordInput;

    // No match. Bail.
    if ( !$el ) { return; }

    // Find the common ancestor
    $commonParent = $el.closest( '[data-component="view-password-toggle"]' );

    // No match. Bail.
    if ( !$commonParent ) { return; }

    // look first for an input that has been tagged previously
    $passwordInput = $commonParent.querySelector( `input[ ${ ATTRIBUTE_INPUT_FLAG } ]` );

    if ( !$passwordInput ) {
        // first click, tag the input with an attribute for future interactions
        $passwordInput = $commonParent.querySelector( "input[ type='password' ]" );
        if ( !!$passwordInput ) {
            $passwordInput.setAttribute( ATTRIBUTE_INPUT_FLAG, "true" );
        }
    }

    // Ok. This must be malformed. Bail.
    if ( !$passwordInput ) { return; }

    // Still good? Toggle away!
    if ( $passwordInput.getAttribute( "type" ) == "password" ) {
        $passwordInput.setAttribute( "type", "text" );
        $el.classList.add( "hide" );
    } else {
        $passwordInput.setAttribute( "type", "password" );
        $el.classList.remove( "hide" );
    }

}

export { togglePassword };
